import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AddCircleOutline, AddOutlined, ChevronLeft, Close, EditOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { validatePermission } from 'helpers/authentication';
import { errorAlert, confirmAlert } from 'helpers/alerts';
import { BackButton, CustomButton, TableData } from "components";
import { setErrorCodesProvider, setErrorCodeSelected } from 'redux/slices/admin/providerSlice';
import { getProviderCredsErrorCodesService, deleteProviderCredsErrorCodesService } from 'services/admin/providerService';
import { Box, Grid } from '@mui/material';

function ErrorCodesHomologadosScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [update, setUpdate] = useState(0);
  const { current, errorCodesProvider } = useSelector(store => store.providers)

  useEffect(() => {
    getProviderCredsErrorCodesService(current.host)
      .then(response => dispatch(setErrorCodesProvider(response)))
      .catch(error => errorAlert(error));
  }, [update]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate('../..')} />
        </div>
        <div className="container-title">
          <div className="title">Proveedor</div>
          <div className="subtitle">{current.container_name}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Box mt={-5}>
        <TableData
          dataRows={errorCodesProvider}
          headerButtons={[
            validatePermission('proveedores', 'proveedores', ['agregar']) &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addProviderCred"
              name={"Nueva Homologación"}
              click={() => navigate("create")}
            />,
          ]}
          dataTitle={[
            "Proveedor",
            "Código HEBE",
            "Etiqueta Proveedor"
          ]}
          formatter={({ hebeExceptionCode, hebeName, externalExceptionCode, connectorName }) => ([
            connectorName,
            `${hebeExceptionCode} - ${hebeName}`,
            externalExceptionCode
          ])}
          actions={[
            validatePermission('proveedores', 'proveedores', ['editar']) &&
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                dispatch(setErrorCodeSelected(data));
                navigate("edit");
              },
            },
            validatePermission('proveedores', 'proveedores', ['editar']) &&
            {
              label: "Eliminar",
              icon: <Close />,
              onClick: ({ sku, id }) => {
                confirmAlert({
                  title: "Estás seguro que deseas eliminar este error code?",
                  text: `Error Code: ${sku} será eliminada.`,
                  onConfirm: async () => {
                    deleteProviderCredsErrorCodesService(id)
                      .then(() => setUpdate(update + 1))
                      .catch(error => errorAlert(error));
                  }
                })
              },
            },
          ]}
        />
      </Box>
    </>
  );
}


export default ErrorCodesHomologadosScreen;